// NOTE: will generate 10,000 unique id's until possibly repeating
// if need be, we should find a real JS based UUID generator
class IdGenerator {
	static getId() {
		return Math.random().toString(36).slice(2);
	}
}

export default IdGenerator;